const NavigationButton = ({ prev = false }) => {
    const classes = (prev ? 'backwards' : '') + ' ' + (prev ? 'swiper-button-prev' : 'swiper-button-next');

    return <button className={`button next ${classes}`}></button>;
};

export default NavigationButton;
